import { Typography } from "@mui/material";
import { FC } from "react";

interface HeaderProps {
    activePage: string;
}

const Header: FC<HeaderProps> = (props) => {
    return (
        <>
            <Typography variant="h4" gutterBottom role="heading">
                {props.activePage}
            </Typography>
        </>
    );
};

export default Header;
